import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Attachment, AttachmentCategoryDetails, BCASearch } from '@app/base/core/models';
import { BuilderService } from '@app/modules/builder/base';
import { SocoHttpService } from '@app/soco/http';
import { process, State } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import {
  GridDataResult,
  DataStateChangeEvent,
  RowArgs,
  SelectAllCheckboxState
} from '@progress/kendo-angular-grid';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
import { SessionService, ConstantsService, AccountService } from '@app/core/services';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { triggerFormValidation, focusFirstInvalidField } from '@app/shared/functions';

declare const $: any;
declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-bca-agreements',
  templateUrl: './bca-agreements.component.html',
  styleUrls: ['./bca-agreements.component.css']
})
export class BcaAgreementsComponent implements OnInit, AfterViewInit {
  // Kendo grid values
  @ViewChild('siteplan', {static: false}) siteplan;
  setClickedRow: Function;
  public SearchResultsGridView: GridDataResult;
  StatusSearchResults: Attachment[];
  selectedRecord: Attachment = new Attachment();
  defaultSkip = 0;
  public comments: any;
  defaultItemsPerPage = 10;
  public routeSubscription: any;
  public GrId: any;
  public name: string;
  public index = 0;
  files: FileList;
  public dupfile = [];
  date1 = new Date('04/09/2018');
  date2 = new Date('04/09/2019');
  public bcaSearch: BCASearch = {
    builderId: [],
    projectName: '',
    projectAddress: '',
    bcaStatus: '',
    subsidaryId: '',
    subsidarycompanyName: '',
    startDate: this.date1,
    endDate: this.date2,
    reqId: '',
    bcaStatusValue: ''
  };
  public rowValue: string;
  public flagerror = false;
  public errorFlag = false;
  public pageSizes = true;
  public previousNext = true;
  documentInput: any = {};
  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public take = 10;
  public state: State = {
    skip: this.defaultSkip,
    take: this.defaultItemsPerPage,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public mySelection: number[] = [];
  public position = this.constsvc.position;
  public stateCd: string;
  public invalidFiles = [];
  public statevalue: SelectAllCheckboxState = 'unchecked';
  public builderId: string[];
  public items: any[];
  public queryParam: any;
  public projectNumber: number;
  public projectName: string;
  public attachmentTitleValue: string;
  public attachmentsCategory = [];
  attachmentCategory: AttachmentCategoryDetails = new AttachmentCategoryDetails();
  dropdownSettings: any;
  builderAttachmentForm: FormGroup;
  requestStatusForm: FormGroup;

  constructor(private builderService: BuilderService,
    private sessionSvc: SessionService, private config: SocoConfigurationService, public constantsSvc: ConstantsService,
    public socoHttp: SocoHttpService, public route: ActivatedRoute,
    public datepipe: DatePipe, public accountService: AccountService, public constsvc: ConstantsService) {

    this.setClickedRow = function(index) {
      this.selectedRow = index;
    };
    this.allData = this.allData.bind(this);

    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Value',
      enableSearchFilter: true
    };
  }

  // on initialisation
  public ngOnInit() {

    if ( this.flagerror === true) {
      $('.fileinput-upload-button').attr('disabled', 'disabled');
    }

    this.attachmentsCategory = [
      { id: 5, itemName: 'OTHER' },// Added OTHER, part of Bug fix-CXCO-1809 - https://so-to.atlassian.net/browse/CXCO-1809
      { id: 4, itemName: 'FINAL PLAT' },
      { id: 2, itemName: 'LOT LIST' },
      { id: 3, itemName: 'PRELIMINARY PLAT' },
      { id: 1, itemName: 'SITE PLAN' },      
    ];

    this.builderAttachmentForm = new FormGroup({
      attachmentCategory: new FormControl(
        null, Validators.required
      ),
      Comments: new FormControl(
        null, Validators.required
      )
    });

    this.requestStatusForm = new FormGroup({  // Init form
      requestId: new FormControl(''),
    }, { updateOn: 'blur' });

    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
    this.GrId = this.route.snapshot.parent.params['id'];
    this.documentInput.RequestId = this.GrId;
    this.documentInput.Folder = this.constantsSvc.folderName;
    this.sessionSvc.builderData.subscribe(success => {
      if (success) {
        this.documentInput.Builder = success.CompanyName;
        this.builderId = success.BuilderId;
        this.sessionSvc.BcaData.subscribe(successBca => {
          if (successBca) {
            this.sessionSvc.GridData.subscribe(result => {
              this.projectNumber = result.projectNumber;
              this.projectName = result.projectName;
              this.documentInput.BcaId = this.projectNumber;
            });
            this.getDocuments();
          }  else {
              for (let i = 0; i < this.builderId.length; i++) {
                this.bcaSearch.builderId.push(this.builderId[i]);
              }
            this.bcaSearch.reqId = this.GrId;
            this.builderService.getBuilderBCADetails(this.bcaSearch).subscribe(result => {
              if (result.data[0].bcaId !== undefined) {
                this.projectNumber = result.data[0].bcaId;
                this.documentInput.BcaId = this.projectNumber;
              }
              this.projectName = result.data[0].projectName;
              this.getDocuments();
            });
          }
        });
      }
    });

    this.state = {
      skip: this.defaultSkip,
      take: this.take
    };

  }

  ngAfterViewInit(): void {
    const url = this.config.webApiBaseUrl;
    this.bindUIComponent(url);
  }
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.take = state.take;
    this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
  }

  get formVal() { return this.builderAttachmentForm.controls; }


  // form validation
  validateForm( formName: string ) {
    if ( this[formName].valid ) {
      return false;
    } else {
      triggerFormValidation(this[formName]);
      focusFirstInvalidField(this[formName]);
      return true;
    }
  }

  // used for excel export data
  public allData(): ExcelExportData {
    return {
      data: process(this.StatusSearchResults, {}).data
    };
  }

// used to display existing documents in grid
getDocuments() {
  this.builderService.findFilesByMetadata(this.documentInput).subscribe(result => {
    if (result.data.length !== 0) {
      for ( let i = 0; i < result.data.length; i++) {
        if (result.data[i]['creationDate'] !== undefined) {
          result.data[i]['creationDate'] = new Date(this.datepipe.transform(result.data[i]['creationDate'], 'MM/dd/yyyy'));
        }
      }
      this.items = result.data;
      this.StatusSearchResults = this.items;
      this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
      this.socoHttp.hidePleaseWait('ContainerAwaiter');
    } else {
      this.StatusSearchResults = [];
      this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
      this.socoHttp.hidePleaseWait('ContainerAwaiter');

    }

  },
  (error) => {
    this.StatusSearchResults = [];
    swal(this.constsvc.errorSwal1, this.constsvc.docErrorSwal, this.constsvc.errorSwal);
    this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
    this.socoHttp.hidePleaseWait('ContainerAwaiter');
  }
 );
}
  selectionChange(ev: any) {
    this.rowValue = ev.index;
    this.selectedRecord = this.StatusSearchResults[this.rowValue];
  }

  public mySelectionKey(context: RowArgs): string {
    return context.dataItem.ProductName + ' ' + context.index;
  }
  public onSelectAllChange(checkedState: SelectAllCheckboxState) {
    if (checkedState === 'checked') {
      this.mySelection = this.items.map(item => item.id);
      this.statevalue = 'checked';
    } else {
      this.mySelection = [];
      this.statevalue = 'unchecked';
    }
  }

  // on submitting file information form
  submitForm() {
    let id = null;
    if (this.requestStatusForm.controls['requestId'].value != null) {
      id = this.requestStatusForm.controls['requestId'].value;
      this.documentInput.Name = id.trim();
    }
  this.getDocuments();
  }

  // used to refresh document grid
  refreshGrid() {
    this.requestStatusForm.patchValue({
      requestId: null
    });
    this.documentInput.Name = null;
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
   this.getDocuments();
  }

  bindUIComponent(url: any) {
    // Modal template
    const modalTemplate =
      '<div class="modal-dialog modal-lg" role="document">\n' +
      '  <div class="modal-content">\n' +
      '    <div class="modal-header">\n' +
      '      <div class="kv-zoom-actions btn-group">{toggleheader}{fullscreen}{borderless}{close}</div>\n' +
      '      <h6 class="modal-title">{heading} <small><span class="kv-zoom-title"></span></small></h6>\n' +
      '    </div>\n' +
      '    <div class="modal-body">\n' +
      '      <div class="floating-buttons btn-group"></div>\n' +
      '      <div class="kv-zoom-body file-zoom-content"></div>\n' +
      '{prev} {next}\n' +
      '    </div>\n' +
      '  </div>\n' +
      '</div>\n';

    // Buttons inside zoom modal
    const previewZoomButtonClasses = {
      toggleheader: 'btn btn-default btn-icon btn-xs btn-header-toggle',
      fullscreen: 'btn btn-default btn-icon btn-xs',
      borderless: 'btn btn-default btn-icon btn-xs',
      close: 'btn btn-default btn-icon btn-xs'
    };

    // Icons inside zoom modal classes
    const previewZoomButtonIcons = {
      prev: '<i class="icon-arrow-left32"></i>',
      next: '<i class="icon-arrow-right32"></i>',
      toggleheader: '<i class="icon-menu-open"></i>',
      fullscreen: '<i class="icon-screen-full"></i>',
      borderless: '<i class="icon-alignment-unalign"></i>',
      close: '<i class="icon-cross3"></i>'
    };

    //
    // AJAX upload
    //

    $('#fileInput').fileinput({
      uploadUrl: url + '/Files/Upload', // server upload action
      uploadAsync: true,
      showCancel: false,
      uploadLabel: 'Upload All',
      allowedPreviewTypes: null,
      msgInvalidFileExtension: 'Invalid extension  for file "{name}"',
      maxFileSize: 50000,
      validateInitialCount: true,
      overwriteInitial: true,
      allowedFileExtensions: ['jpg', 'gif', 'png', 'txt', 'asm', 'doc', 'docx', 'docm', 'dot', 'dotx',
    'dotm', 'jpe', 'jpeg', 'pdf', 'pnz', 'ppt', 'pptm', 'pptx', 'tiff', 'tif', 'xlc', 'xls', 'xlsx', 'xlsm', 'xlt'],
      uploadClass: 'btn bg-teal-400',
      removeClass: 'btn btn-danger',
      maxFileCount: 5,
      initialPreview: [],
      fileActionSettings: {
        removeIcon: '<i class="icon-bin"></i>',
        removeClass: 'btn btn-danger',
        uploadIcon: '<i class="icon-upload"></i>',
        uploadClass: 'btn bg-teal-400',
        zoomIcon: '<i class="icon-zoomin3"></i>',
        zoomClass: 'btn btn-link btn-xs btn-icon',
        indicatorNew: '<i class="icon-file-plus text-slate"></i>',
        indicatorSuccess: '<i class="icon-checkmark3 file-icon-large text-success"></i>',
        indicatorError: '<i class="icon-cross2 text-danger"></i>',
        indicatorLoading: '<i class="icon-spinner2 spinner text-muted"></i>',
      },
      layoutTemplates: {
        icon: '<i class="icon-file-check"></i>',
        modal: modalTemplate
      },

      initialCaption: 'No file selected',
      previewZoomButtonClasses: previewZoomButtonClasses,
      previewZoomButtonIcons: previewZoomButtonIcons,
      uploadExtraData: function (previewId, index) {
        const formValueBuilder = this.documentInput.Builder;
        const formValueBcaNumber = this.documentInput.BcaId;
        const formValueRequestNumber = this.documentInput.RequestId;
        const formValueComments = this.builderAttachmentForm.controls.Comments.value;
        const formValueFolder = this.documentInput.Folder;
        const formValueDocumentType = this.builderAttachmentForm.controls.attachmentCategory.value ?
        this.builderAttachmentForm.controls.attachmentCategory.value.itemName : null;
        const uploadedBy = this.accountService ? this.accountService.account.user.username : '';
        return { builder: formValueBuilder, requestId: formValueRequestNumber, comments: formValueComments,
          bcaId: formValueBcaNumber, folder: formValueFolder, uploadedBy: uploadedBy, documentType: formValueDocumentType  };
      }.bind(this)
       }).on('fileremoved', function (event, id, index) {

        this.dupfile = this.dupfile.filter(x => x.id !== Number(index));
        if (this.invalidFiles.indexOf(index) > -1) {
          this.invalidFiles = this.invalidFiles.filter(item => item !== index);
        }
        if (this.invalidFiles.length === 0) {
          this.flagerror = false;
        }
      $('.file-input-ajax').on('fileuploaderror', function (event, data, msg) {
          if (this.errorFlag === false) {
            this.flagerror = true;
            $('.fileinput-upload-button').attr('disabled', 'disabled');
          }
        }.bind(this));
        if (this.flagerror === false) {
          $('.fileinput-upload-button').removeAttr('disabled');
        }
      }
        .bind(this));
    $('#fileInput').on('fileselect', function(event, numFiles, label) {
    });
   $('#fileInput').on('change', (event) => {
    if ( this.dupfile.length === 0) {
      this.index = 0;
     }
    this.files = event.target.files;
   if (this.dupfile.length < 5) {
     for (let i = 0; i < this.files.length; i++) {
       if ( !this.dupfile.find(x => x.item === this.files.item(i).name)) {
                  this.dupfile.push({id: this.index, item: this.files.item(i).name});
       } else {
         this.name  = this.files.item(i).name;
       const message = `<strong>There is a same file with the name: <strong>`;
       const message1 = `<p><strong>So skipping duplicate selection!<strong></p>`;
       const tag = document.createElement('strong');
             const msg = document.createElement('div');
             const msg1 = document.createElement('span');
             const textNode = document.createTextNode(this.name);
             tag.appendChild(textNode);
             msg.innerHTML = message;
             msg1.innerHTML = message1;
             msg.appendChild(tag);
             msg.appendChild(msg1);
             swal({
               content: msg,
               icon: 'assets/images/icons/exclamation.png',
               buttons: {
                 cancel: {
                   text: 'Cancel',
                   visible: true,
                   value: false,
                   closeModal: true
                 },
               }
             });
       }
        this.index = this.index + 1;
     }
   }

});

      $('#fileInput').on('fileuploaded', function (event, data, id, index) {
        const fname = data.files[index].name,
         out = '<li>' + 'Uploaded file # ' + (index + 1) + ' - ' + fname + ' successfully.' + '</li>';
        $('#kv-success-1 ul').append(out);
        $('#kv-success-1').fadeIn('slow');
        if ( Number(index) + 1 === data.files.length ) {
          setTimeout(() => {
            $('.close.fileinput-remove').click();
        }, 1000);
        const response = data.response;
        if (response !== undefined) {
          if (response.statusCode === 201) {
             const msg = 'File uploaded successfully';
            swal(this.constsvc.successSwal1, msg, this.constsvc.successSwal);
          } else {
            swal(this.constsvc.errorSwal1, 'File Upload Failed', this.constsvc.errorSwal);
          }
        } else {
            swal(this.constsvc.errorSwal1, 'File Upload Failed', this.constsvc.errorSwal);
        }
        this.builderAttachmentForm.reset();
        this.builderAttachmentForm.clearValidators();
      this.refreshGrid();

    }
  }.bind(this));

  $('#fileInput').on('filecleared', function(event) {
    this.invalidFiles = [];
    this.dupfile = [];
    this.flagerror = false;
    this.index = 0;
    $('.fileinput-upload-button').removeAttr('disabled');
}.bind(this));

  $('#fileInput').on('filepreupload', function(event, data, previewId, index, jqXHR) {
    const validationError = this.validateForm('builderAttachmentForm');
    const msg = 'Please select the required fields';

    if (validationError) {
      swal(this.constantsSvc.errorSwal1, msg, this.constantsSvc.errorSwal);
       return {message: 'You are not allowed to do that'};

   }
  }.bind(this));

  $('#fileInput').on('fileuploaderror', function(event, data, msg) {
    if (data.id !== null) {
      $('.fileinput-upload-button').attr('disabled', 'disabled');
      this.flagerror = true;

      if (!this.invalidFiles.includes(data.id)) {
        this.invalidFiles.push(data.id);
      }
    } else {
      this.errorFlag = true;
    }
  }.bind(this));


  $('#fileInput').on('fileloaded', function() {
    if (this.flagerror === true) {
      $('.fileinput-upload-button').attr('disabled', 'disabled');
    }
}.bind(this));
}

}

